export var httpHandlerOptions = {
    bufferBody: false,
};
//# sourceMappingURL=httpHandlerOptions.js.map